import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

function CheckboxInput({ isChecked, label, className = "", onChange }: Props) {
  return (
    <label
      className={classNames(styles.checkboxInput, className)}
      data-checked={isChecked}
    >
      <input
        className={styles.input}
        type="checkbox"
        value=""
        onChange={(e) => onChange(e.currentTarget.checked)}
        checked={isChecked}
      />
      <span
        className={styles.control}
        aria-hidden="true"
        data-checked={isChecked}
      >
        {isChecked && (
          <svg className={styles.icon} viewBox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1" />
          </svg>
        )}
      </span>
      {label && (
        <span className={styles.label} data-checked={isChecked}>
          {label}
        </span>
      )}
    </label>
  );
}

export { CheckboxInput };
